/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Represents a single event in the annual clock
 * @export
 * @interface AnnualClockEvent
 */
export interface AnnualClockEvent {
    /**
     *
     * @type {string}
     * @memberof AnnualClockEvent
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof AnnualClockEvent
     */
    url?: string | null;
    /**
     *
     * @type {string}
     * @memberof AnnualClockEvent
     */
    date?: string | null;
}

/**
 * Check if a given object implements the AnnualClockEvent interface.
 */
export function instanceOfAnnualClockEvent(value: object): value is AnnualClockEvent {
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function AnnualClockEventFromJSON(json: any): AnnualClockEvent {
    return AnnualClockEventFromJSONTyped(json, false);
}

export function AnnualClockEventFromJSONTyped(json: any, _: boolean): AnnualClockEvent {
    if (json == null) {
        return json;
    }
    return {

        'title': json['title'],
        'url': json['url'] ?? undefined,
        'date': json['date'] ?? undefined,
    };
}

export function AnnualClockEventToJSON(json: any): AnnualClockEvent {
    return AnnualClockEventToJSONTyped(json, false);
}

export function AnnualClockEventToJSONTyped(value?: AnnualClockEvent | null, _: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'title': value['title'],
        'url': value['url'],
        'date': value['date'],
    };
}
